import { useState } from "react";
import { CalendarPlus, MailX, CheckCircle2, XCircle, LoaderCircle } from "lucide-react";
import { api, apiError } from "@/lib/api";

// Odkazy z e-mailů kampaně pro dema (174): /demo/prodlouzit a /demo/odhlasit.
// Akce běží až po kliknutí na tlačítko (POST) — skener odkazů v poště ji tak nespustí sám.
const ACTIONS = {
  prodlouzit: {
    icon: CalendarPlus, title: "Prodloužit demo o 7 dní",
    text: "Jedním klikem získáte dalších 7 dní plné verze. Všechna vaše data zůstávají.",
    button: "Prodloužit demo", endpoint: "/demo/extend",
    done: (d) => `Demo běží do ${new Date(d.trial_ends_at).toLocaleDateString("cs-CZ")}. Přihlaste se a pokračujte.`,
  },
  odhlasit: {
    icon: MailX, title: "Odhlásit tipy k demu",
    text: "Přestaneme vám posílat tipy a připomínky k demu. Důležité e-maily (hesla, platby) chodí dál.",
    button: "Odhlásit tipy", endpoint: "/demo/unsubscribe",
    done: () => "Hotovo. Tipy k demu vám už chodit nebudou.",
  },
};

export default function DemoAction({ action }) {
  const a = ACTIONS[action];
  const token = new URLSearchParams(window.location.search).get("t");
  const [state, setState] = useState(token ? "idle" : "error"); // idle | busy | done | error
  const [msg, setMsg] = useState(token ? "" : "Odkaz je neúplný. Otevřete ho prosím znovu z e-mailu.");
  const Icon = a.icon;

  const run = async () => {
    setState("busy");
    try {
      const { data } = await api.post(a.endpoint, { t: token });
      setMsg(a.done(data)); setState("done");
    } catch (e) {
      setMsg(apiError(e)); setState("error");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid={`demo-${action}-page`}>
      <div className="w-full max-w-[480px] bg-card border border-border rounded-[20px] shadow-xl px-6 sm:px-8 py-10 text-center">
        {state === "done" ? <CheckCircle2 size={44} className="mx-auto mb-4 text-success" />
          : state === "error" ? <XCircle size={44} className="mx-auto mb-4 text-destructive" />
          : <Icon size={40} className="mx-auto mb-4 text-brand" />}
        <h1 className="text-xl font-extrabold mb-2">{a.title}</h1>
        <p className="text-sm text-muted-foreground mb-6">{state === "idle" || state === "busy" ? a.text : msg}</p>
        {(state === "idle" || state === "busy") && (
          <button type="button" onClick={run} disabled={state === "busy"} data-testid="demo-action-btn"
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-[14px] bg-brand text-white font-bold w-full md:w-auto disabled:opacity-60">
            {state === "busy" && <LoaderCircle size={16} className="animate-spin" />}{a.button}
          </button>
        )}
        {state === "done" && action === "prodlouzit" && (
          <a href="/login" className="inline-flex items-center justify-center h-11 px-6 rounded-[14px] bg-brand text-white font-bold w-full md:w-auto">
            Přihlásit se
          </a>
        )}
      </div>
    </div>
  );
}
